module.exports = __webpack_public_path__ + "static/aire-acondicionado-7a6dafec89404ad1aaea2ac6d3f12922.jpg";